export default "__VITE_PUBLIC_ASSET__06c3a1d6__"